import Loader from '@components/state/Loader'
import { Route } from '@config/routes/routes.enums'
import { useAuth } from '@services/contexts/AuthContext'
import Cookies from 'js-cookie'
import React, { useEffect } from 'react'
import {
	useNavigate,
	useSearchParams
} from 'react-router-dom'

/**
 * Login
 * @constructor
 */
const Login = () => {
	const navigate = useNavigate()
	const [searchParams] = useSearchParams()
	const { storeToken } = useAuth()

	useEffect(() => {
		const token = Cookies.get('token')
		const exp = Number(Cookies.get('exp'))
		const redirect_uri = searchParams.get('redirect_uri')

		if (token && exp) {
			storeToken({ token, exp })
		}

		navigate(redirect_uri ?? `/${Route.HOME}`)
	}, [navigate, searchParams, storeToken])

	return <Loader />
}

export default Login
